import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 *
 * Simple Modal Footer Component
 *
 * Input Properties:
 *  checkbox: optional object with a label, a value and an optional disabled flag for a checkbox
 *  disableSubmission: Whether the submit button should be disabled or not. Defaults to false
 *  errorText: The text to display when there is an error
 *  noteText: The text to display as a note to the user
 *  selectedItemCount: How many items have been selected in this modal
 *  submitButtonText: The text that should be used for the submit button. Defaults to 'Submit'
 *  cancelButtonText: The text that should be used for the cancel button. Defaults to 'Cancel'
 *  deleteButtonText: The text that should be used for the delete button. If not provided, the delete button will not be shown
 *  showSubmitButton: Whether the submit button should be shown. Defaults to true
 *  showCancelButton: Whether the cancel button should be shown. Defaults to true
 *  modalTestId: A Unique Test id corresponding to the parent modal. Used to set the data-test-id attribute
 *               for the confirm and cancel buttons
 *
 * Output Properties:
 *  cancelHandler: emits when the user clicks Cancel
 *  checkboxHandler: emits the checkbox value when it changes
 *  submitHandler: emits when the user clicks Submit
 *  deleteHandler: emits when the user clicks Delete
 *
 */

@Component({
    standalone: false,
    selector: 'ycn-simple-modal-footer',
    templateUrl: './simple-modal-footer.template.html',
})
export class SimpleModalFooterComponent implements OnInit {
    @Input() checkbox?: { label: string; value: boolean; disabled?: boolean };

    @Input() cancelButtonText?: string;

    @Input() disableSecondary?: boolean;

    @Input() disableSubmission?: boolean;

    @Input() errorText?: string;

    @Input() noteText?: string;

    @Input() deleteButtonText?: string;

    @Input() secondaryButtonText?: string;

    @Input() selectedItemCount?: number;

    @Input() submitButtonText?: string;

    @Input() showSubmitButton: boolean = true;

    @Input() showCancelButton: boolean = true;

    @Input() modalTestId?: string;

    @Input() loading?: boolean;

    @Input() secondaryButtonClasses?: string | string[] | Set<string> | { [p: string]: any } | null = 'btn-primary';

    @Input() submitButtonClasses?: string | string[] | Set<string> | { [p: string]: any } | null = 'btn-primary';

    @Output() cancelHandler = new EventEmitter<void>();

    @Output() checkboxHandler = new EventEmitter<boolean>();

    @Output() deleteHandler = new EventEmitter<void>();

    @Output() secondaryHandler = new EventEmitter<void>();

    @Output() submitHandler = new EventEmitter<void>();

    ngOnInit(): void {
        this.cancelButtonText = this.cancelButtonText || 'Cancel';
        this.submitButtonText = this.submitButtonText || 'Submit';
        this.disableSubmission = this.disableSubmission || false;
    }
}
